// http.js - 完整整合混淆后缀逻辑

import axios from 'axios';
import router from '../router';
import qs from 'qs';
import vant, { Toast } from 'vant';
import JSONBIG from 'json-bigint';
import VConsole from 'vconsole';
import plugins from '../plugins';
import regular from '../utils/regular';
import CryptoJS from 'crypto-js';

export default {
  install: Vue => {
    Vue.use(vant);
    Vue.use(plugins);
    if (process.env.VUE_APP_IS_LOG == 1) {
      const vConsole = new VConsole();
      Vue.use(vConsole);
    }
    Vue.prototype.$rg = regular;
    Vue.prototype.$axios = axios;

    axios.defaults.transformResponse = [
      function (data) {
        const json = JSONBIG({ storeAsString: true });
        return json.parse(data);
      }
    ];

    axios.defaults.timeout = 30000;
    const no_login_code = -1;
    const success_code = 1;
    const err_code = 0;
    const token_headers = true;

    console.warn(`%c ${process.env.NODE_ENV} `, 'background:#328ee6;border-radius:3px;color: #ffffff');

    // 支持根据当前页面主域名动态设置API路径
    // 优先检查是否配置了使用当前域名的环境变量
    const useCurrentDomain = process.env.VUE_APP_USE_CURRENT_DOMAIN === 'true';
    
    if (useCurrentDomain && typeof window !== 'undefined') {
      // 在浏览器环境中使用当前页面主域名
      const hostname = window.location.hostname;
      setpath(`https://${hostname}`);
    } else if (process.env.NODE_ENV == 'development') {
      setpath('https://api.ltnova.com');
    } else if (process.env.NODE_ENV == 'production') {
      setpath('https://api.ltnova.com');
    }

    function setpath(api_path = '', web_path = api_path, ws_path = '') {
      // 确保api_path有有效的协议前缀
      if (api_path && !api_path.startsWith('http')) {
        api_path = `https://${api_path}`;
      }
      axios.defaults.baseURL = `${api_path}/api/v1`;
      Vue.prototype.httpPath = web_path;
      Vue.prototype.wsPath = ws_path;
    }

	function getObfuscationSuffix() {
	  const OBFS_SECRET = '688989cc-0a54-8330-913d-ac43e9c8b122';
	  const date = new Date();
	  const baseStr = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

	  const count = 60;
	  const suffixes = Array.from({ length: count }, (_, i) => {
		const slot = baseStr + '-' + i;
		const hash = CryptoJS.HmacSHA256(slot, OBFS_SECRET).toString();
		return hash.substring(0, 8);
	  });

	  const randomIndex = Math.floor(Math.random() * suffixes.length);
	  return suffixes[randomIndex];
	}
	const memberInfoPaths = [
	  '/member/getMemberInfo',
	  '/member/getMembeInfo',
	  '/member/getMembInfo',
	  '/member/getMemInfo',
	  '/member/getMeInfo',
	  '/member/getMInfo',
	  '/member/getInfo'
	];
	
	function randomMemberInfoPath() {
	  const idx = Math.floor(Math.random() * memberInfoPaths.length);
	  return memberInfoPaths[idx];
	}
    function obfuscateUrl(url) {
		if (url === '/member/getMemberInfo') {
			url = randomMemberInfoPath();
		}
      const skipExtensions = ['.png', '.jpg', '.jpeg', '.webp', '.svg', '.js', '.css', '.json'];
      if (skipExtensions.some(ext => url.endsWith(ext))) return url;
      const suffix = getObfuscationSuffix();
      const [path, query] = url.split('?');
      return query !== undefined ? `${path}${suffix}?${query}` : `${path}${suffix}`;
    }

    Vue.prototype.$get = params => {
      const token = Vue.prototype.local.get("token") || "";
      const localTxt = Vue.prototype.local.get("lang");
      let data = {};
      params.loading && Toast.loading({ forbidClick: true, duration: 0 });
      if (token_headers) {
        data = {
          params: Object.assign({}, params.data),
          headers: {
            'authorization': `Bearer ${token}`,
            'locale': localTxt
          }
        };
      } else {
        data = {
          params: Object.assign({}, params.data, token ? { token } : ''),
          headers: { 'locale': localTxt }
        };
      }

      axios.get(obfuscateUrl(params.url), data).then(res => {
        params.loading && Toast.clear();
        if (res.data.code == no_login_code) {
          if (token) Vue.prototype.local.del("token");
          Toast({
            message: '未登录',
            onClose: () => { router.replace('login'); }
          });
        } else if (res.data.code == success_code) {
          params.success && params.success(res.data);
        } else if (res.data.code == err_code) {
          if (params.tip) {
            params.tip(res.data);
            Toast(res.data.message);
          } else if (params.tips) {
            params.tips(res.data);
          }
        }
      }).catch(err => {
        console.log('请求失败', err.response);
        err.response && Toast(`${err.response.config.url} ${err.response.status}`);
      });
    };

    Vue.prototype.$post = params => {
      const token = Vue.prototype.local.get("token") || "";
      const localTxt = Vue.prototype.local.get("lang");
      let data = {}, headers = {};
      params.loading && Toast.loading({ forbidClick: true, duration: 0 });

      if (token_headers) {
        headers['Authorization'] = `Bearer ${token}`;
        headers['locale'] = localTxt;
        if (params.upload) {
          headers['Content-Type'] = 'multipart/form-data';
          data = params.data;
        } else if (params.noToken) {
          headers = { 'locale': localTxt };
          data = params.data;
        } else if (params.raw) {
          headers['Content-Type'] = 'multipart/form-data';
          data = params.data;
        } else {
          data = qs.stringify(Object.assign({}, params.data));
        }
      } else {
        if (params.upload) {
          data = params.data.append('token', token ? token : "");
          headers['locale'] = localTxt;
          headers['Content-Type'] = 'multipart/form-data';
        } else if (params.noToken) {
          data = qs.stringify(Object.assign({}, params.data));
          headers['locale'] = localTxt;
        } else {
          data = qs.stringify(Object.assign({}, params.data, token ? { token } : {}));
          headers['locale'] = localTxt;
        }
      }

      axios.post(obfuscateUrl(params.url), data, { headers }).then(res => {
        params.loading && Toast.clear();
        if (res.data.code == no_login_code) {
          if (token) Vue.prototype.local.del("token");
          Toast({
            message: '未登录',
            onClose: () => { router.replace('login'); }
          });
        } else if (res.data.code == success_code) {
          params.success && params.success(res.data);
        } else if (res.data.code == err_code) {
          if (params.tip) {
            params.tip(res.data);
            Toast(res.data.message);
          } else if (params.tips) {
            params.tips(res.data);
          }
        }
      }).catch(err => {
        console.log('请求失败', err.response);
        err.response && Toast(`${err.response.config.url} ${err.response.status}`);
      });
    };
  }
};